import { ApolloLink } from '@apollo/client';
/*
  A link to allow the user of the ApolloProvider to provide some default headers for the entire client.
*/
export const makeHeaderLink = (user, headers) => {
    return new ApolloLink((operation, forward) => {
        const additionalHeaders = {};
        if (user) {
            additionalHeaders['Amazon-Advertising-AAPN-Id-Token'] = user.id_token;
        }
        const existingContext = operation.getContext();
        // prefer "existingHeaders" to any supplied here, as they can be set from the request side.
        const mergedHeaders = Object.assign(Object.assign(Object.assign({}, additionalHeaders), headers), existingContext.headers);
        operation.setContext(Object.assign(Object.assign({}, existingContext), { headers: mergedHeaders }));
        return forward(operation);
    });
};
